import { Button, Typography } from '@neo4j-ndl/react';
import { APP_SCOPE } from '@nx/constants';
import { createLogger } from '@nx/logger/legacy';
import { addNotification, consoleApi, getApiError, getErrorMessage, logout } from '@nx/state';
import { isNotNullish, isNullish } from '@nx/stdlib';
import { PadlockIllustration, Page } from '@nx/ui';
import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

const logger = createLogger(APP_SCOPE.framework);

export const MfaEnabledError = () => {
  const [updateUserMfaEnabled] = consoleApi.useUpdateUserPreferenceMfaMutation();
  const { data: user } = consoleApi.useGetUserDetailsQuery();

  const handleUpdateMfaEnabled = () => {
    if (isNullish(user)) {
      return;
    }
    updateUserMfaEnabled({ userId: user.id, mfaEnabled: true })
      .unwrap()
      .then(() => {
        logout();
      })
      .catch((e: FetchBaseQueryError | SerializedError | undefined) => {
        const apiError = getApiError(e);
        if (isNotNullish(apiError.message)) {
          logger.error(apiError.message);
        }
        addNotification({
          type: 'danger',
          title: 'Failed to enable MFA',
          description: getErrorMessage(apiError),
          timeout: 5000,
        });
      });
  };

  return (
    <Page as="div" className="h-full items-center justify-center">
      <div className="flex flex-1 flex-row items-center justify-center gap-2">
        <div className="flex size-[236px] items-center justify-center">
          <PadlockIllustration />
        </div>
        <div className="flex max-w-[600px] flex-col justify-center gap-4">
          <Typography variant="h3" className="font-syne font-medium">
            MFA is required for this organization
          </Typography>
          <Typography variant="body-large" className="text-neutral-text-weak">
            Your organization owner has required Multi Factor Authentication (MFA) for this organization. Log out and
            then in again using your email and password to configure MFA
          </Typography>
          <Button className="mt-4 w-fit" onClick={handleUpdateMfaEnabled}>
            Log out
          </Button>
        </div>
      </div>
    </Page>
  );
};
